import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Typography, Box } from '@mui/material';
import { Flex } from 'reflexbox';
import { useSelector } from 'react-redux';
import * as route from '../components/helpers/routes';
import { PersonalProfileForm } from '../components/PersonalProfileDisplayAndEdit';
import { writePersonalNameAndAvatar } from '../helpers/dbFunctions';
import profanityChecker from '../components/helpers/profanityChecker';
import PageHeader from '../components/gamePlayComponents/PageHeader';

const ProfileSetup = () => {
  const navigate = useNavigate();
  const user = useSelector((state) => state.user);
  const { uid, name, color, character } = user;
  const [localName, setLocalName] = useState(name || '');
  const [localColor, setLocalColor] = useState(color || '');
  const [localCharacter, setLocalCharacter] = useState(character ?? '');
  const [profanityError, setProfanityError] = useState(false);

  useEffect(() => {
    const hasExistingProfile =
      (name && name.trim()) ||
      color ||
      (character !== undefined && character !== null && character !== '');

    if (hasExistingProfile) {
      navigate(route.JOINORHOST, { replace: true });
    }
  }, [name, color, character, navigate]);

  const hasSelection = Boolean(
    localName.trim() ||
    localColor ||
    (localCharacter !== undefined && localCharacter !== null && localCharacter !== '')
  );

  const handleNameChange = (value) => {
    setLocalName(value);
    setProfanityError(profanityChecker(value));
  };

  const handleContinue = () => {
    if (hasSelection) {
      writePersonalNameAndAvatar(uid, localName, localColor, localCharacter);
    }
    navigate(route.JOINORHOST, { replace: true });
  };

  return (
    <Flex
      flexDirection="column"
      justifyContent="space-between"
      style={{ height: '100%' }}
    >
      <PageHeader goBack title="Tell us about yourself" />

      <Box sx={{ px: 2, flex: 1 }}>
        <PersonalProfileForm
          name={localName}
          color={localColor}
          character={localCharacter}
          onNameChange={handleNameChange}
          onColorChange={setLocalColor}
          onCharacterChange={setLocalCharacter}
          nameError={profanityError}
        />
      </Box>

      <Box sx={{ p: 2 }}>
        <Button
          variant="contained"
          color="primary"
          fullWidth
          disabled={profanityError}
          onClick={handleContinue}
        >
          {hasSelection ? 'Next' : 'Skip'}
        </Button>
        {profanityError && (
          <Typography
            variant="caption"
            color="text.secondary"
            sx={{ display: 'block', mt: 1, textAlign: 'center' }}
          >
            Please choose a name that meets our community guidelines.
          </Typography>
        )}
      </Box>
    </Flex>
  );
};

export default ProfileSetup;
